import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { PrimaryBtn, GhostBtn } from "@/components/admin/ui";
import { Check, X, User, Phone, Mail } from "lucide-react";

export default function UsersPanel() {
  const [pending, setPending] = useState([]);

  const load = () => api.get("/admin/users/pending").then((r) => setPending(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const approve = async (id) => {
    await api.post(`/users/${id}/approve`);
    toast.success("Membro approvato");
    load();
  };
  const reject = async (id) => {
    await api.post(`/users/${id}/reject`);
    toast("Membro rifiutato");
    load();
  };

  return (
    <div>
      <h2 className="font-heading text-xl font-bold uppercase text-zinc-100 mb-2">Membri</h2>
      <p className="text-sm text-zinc-500 mb-6">Iscrizioni in attesa di approvazione.</p>

      {pending.length === 0 ? (
        <p className="text-zinc-500 py-10 text-center" data-testid="empty-members">Nessuna iscrizione in attesa.</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {pending.map((u) => (
            <div key={u.id} data-testid={`member-${u.id}`} className="border border-yellow-400/30 bg-zinc-900 p-5">
              <h3 className="font-heading text-lg font-bold text-zinc-50 flex items-center gap-2">
                <User className="h-4 w-4 text-cyan-400" /> {u.name}
              </h3>
              {u.race_type && (
                <span data-testid={`member-race-${u.id}`} className="mt-2 inline-flex items-center border border-cyan-500/40 bg-cyan-500/10 text-cyan-300 text-[10px] font-bold tracking-[0.15em] uppercase px-2.5 py-1 rounded-full">
                  {u.race_type === "entrambe" ? "RC + SIM" : u.race_type.toUpperCase()}
                </span>
              )}
              <div className="mt-2 space-y-1 text-sm text-zinc-400">
                <div className="flex items-center gap-2"><Mail className="h-3.5 w-3.5" /> {u.email}</div>
                <div className="flex items-center gap-2"><Phone className="h-3.5 w-3.5" /> {u.phone || "—"}</div>
              </div>
              <div className="mt-4 flex gap-2">
                <PrimaryBtn onClick={() => approve(u.id)} data-testid={`approve-user-${u.id}`} className="flex-1">
                  <Check className="h-4 w-4" /> Approva
                </PrimaryBtn>
                <GhostBtn onClick={() => reject(u.id)} data-testid={`reject-user-${u.id}`}>
                  <X className="h-4 w-4" /> Rifiuta
                </GhostBtn>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
